import { render, staticRenderFns } from "./VcardLayout.vue?vue&type=template&id=19cb007b"
import script from "./VcardLayout.vue?vue&type=script&lang=ts"
export * from "./VcardLayout.vue?vue&type=script&lang=ts"
import style0 from "./VcardLayout.vue?vue&type=style&index=0&id=19cb007b&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports